import { array, boolean, string, struct } from 'io-ts/Decoder';

const BomNoteDecoder = struct({
	value: string,
	hidden: boolean,
});

export const Request = struct({
	notes: array(BomNoteDecoder),
});
